interface ArrowUpRightIconProps {
    size?: number;
    strokeColor?: string;
    className?: string;
}

export function ArrowUpRightIcon({
    size = 20,
    strokeColor = "#1C3BD9",
    className
}: ArrowUpRightIconProps) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.83331 14.1666L14.1666 5.83325M14.1666 5.83325H5.83331M14.1666 5.83325V14.1666"
                stroke={strokeColor}
                strokeWidth={size / 12}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
